<template>
  <div>
    <div v-if="!isAvailable" :data-cy="`card-${card.sequence}-invalid`" class="mb-2">
      <info-icon
        id="available-points"
        v-b-tooltip="{
          title: invalidToolTipText,
          placement: 'bottom',
          customClass: 'credit-card-tooltip'
        }"
        class="info-icon"
      />
      <span>{{ $t('creditCardForm.creditCardInvalid') }}</span>
    </div>
    <h5 v-if="cardBrand" class="font-weight-bold">{{ cardBrand }}</h5>
    <!-- Card number -->
    <b-row no-gutters>
      <label class="font-weight-bold">{{ $t('creditCardForm.cardNumber') }}</label>
    </b-row>
    <b-row no-gutters>
      <span>{{ card.number }}</span>
    </b-row>
    <!-- End of Card number -->

    <!-- Card holder's name -->
    <template v-if="card.name">
      <b-row no-gutters>
        <label class="font-weight-bold mb-1">{{ $t('creditCardForm.cardHolder') }}</label>
      </b-row>
      <b-row no-gutters>
        <span class="mb-2">{{ card.name }}</span>
      </b-row>
    </template>
    <!-- End of Card holder's name -->

    <!-- Card expiry -->
    <b-row no-gutters>
      <label class="font-weight-bold">{{ $t('creditCardForm.cardExpiration') }}</label>
    </b-row>
    <b-row no-gutters>
      <span>{{ card.expire }}</span>
    </b-row>
    <!-- End of Card expiry -->

    <slot name="action"></slot>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

import InfoIcon from 'assets/info-red.svg?inline'
import { ThirdPartyPayment } from 'constants/tripla'
import BrowsingState from 'utilities/BrowsingState'

export default {
  name: 'RegisteredCreditCard',
  components: {
    InfoIcon
  },
  props: {
    card: {
      type: Object,
      required: true
    },
    isAvailable: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    ...mapGetters({
      paymentGatewaySetting: 'setting/getPaymentGatewaySetting',
      hotelCode: 'setting/getHotelCode'
    }),
    cardBrand() {
      if (this.card.card_brand && this.$te(`gmoPaypalOptions.${this.card.card_brand}`)) {
        return this.$t(`gmoPaypalOptions.${this.card.card_brand}`)
      } else {
        if (this.card.gateway === 'adyen') {
          if (this.card.card_brand === 'mc') return 'Mastercard'
          if (this.card.card_brand === 'visa') return 'Visa'
        }
        return this.card.card_brand
      }
    },
    invalidToolTipText() {
      const { Paygent, GMO } = ThirdPartyPayment
      // load the BrowsingState because Payment Options page is disconnected from the information inside the Booking page
      const { query } = BrowsingState.load(this.hotelCode, { isRemove: false }) || {}
      const isMCPCurrency = query?.mcp_currency !== 'JPY' || false
      if (!isMCPCurrency && [Paygent, GMO].includes(this.paymentGatewaySetting?.name))
        return this.$t('creditCardForm.badCards')

      return this.$t('creditCardForm.creditCardInvaildHoverText')
    }
  }
}
</script>
